import { avatarSizes } from 'shared/consts'
import avatarPath from 'assets/images/artist-default.svg'

export const getArtistImagePath = (
  spotifyId: string | undefined | null,
  facebookId: string | undefined | null,
  size: keyof typeof avatarSizes
) => {
  const myRegexp = /artist(.*)/
  const match = myRegexp.exec(spotifyId || '') || []
  const spotifyIdString = spotifyId?.includes('artist') || spotifyId?.includes('user') ? match[1] : `/${spotifyId}`

  if (spotifyId?.length && spotifyIdString) {
    return `${process.env.REACT_APP_COVERS_URL}/artists/spotify${spotifyIdString}?size=${avatarSizes[size]}`
  }

  if (facebookId?.length) {
    return `${process.env.REACT_APP_COVERS_URL}/artists/facebook/${facebookId.replace('/', '')}?size=${
      avatarSizes[size]
    }`
  }

  return avatarPath
}
